import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import resourcesToBackend from 'i18next-resources-to-backend';

const STORAGE_KEY = 'zeus_language';
const DEFAULT_LANGUAGE = 'it';

const savedLanguage = typeof window !== 'undefined' && window.localStorage 
  ? localStorage.getItem(STORAGE_KEY) || DEFAULT_LANGUAGE
  : DEFAULT_LANGUAGE;

i18n
  .use(resourcesToBackend((language: string, namespace: string) => 
    import(`../public/locales/${language}/${namespace}.json`)
  ))
  .use(initReactI18next)
  .init({
    lng: savedLanguage,
    fallbackLng: DEFAULT_LANGUAGE,
    defaultNS: 'common',
    ns: ['common'],
    
    interpolation: {
      escapeValue: false,
    },
    
    react: {
      useSuspense: true,
    },
    
    debug: false,
  });

i18n.on('languageChanged', (lng: string) => {
  if (typeof window !== 'undefined') {
    if (window.localStorage) {
      localStorage.setItem(STORAGE_KEY, lng);
    }
    if (document?.documentElement) {
      document.documentElement.lang = lng;
    }
  }
});

export default i18n;
